import { render } from "./ReloadAndRedirectPage.vue?vue&type=template&id=31132a4c"
import script from "./ReloadAndRedirectPage.vue?vue&type=script&lang=js"
export * from "./ReloadAndRedirectPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__